export type OpenHamburgerHandler = EmptyArgsVoidFunc;

export enum WrapperVisible {
  none = 'none',
  flex = 'flex',
}
